/** import external dependencies */
import 'jquery';
import 'bootstrap';

/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import displayAreas from './routes/areas';
import aboutUs from './routes/about';
import singleProducts from './routes/products';
import contactUs from './routes/contact';
//import './routes/nav'; 
/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  common,
  home,
  singleProducts,
  contactUs,
  displayAreas,
  aboutUs,
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js